<template>
  <v-row>
    <v-col cols="12">
      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFormatted"
            :label="label"
            :name="name"
            :data-vv-as="label"
            persistent-hint
            autocomplete="off"
            placeholder="dd/mm/aaaa"
            maxlength="10"
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            v-validate="required()"
            :dense="dense"
            :disabled="isViewModal || disabled"
            @click:prepend="openMenu"
            @input="onInput"
            @blur="onBlur"
            @keydown.enter="onBlur"
          ></v-text-field>
          <span class="red--text">{{ errors.first(name) }}</span>
        </template>
        <v-date-picker v-model="fecha" no-title @change="onPick"></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    date: { default: null, type: String },
    initToday: { default: false, type: Boolean },
    label: { default: "Date", type: String },
    name: { default: "date", type: String },
    isRequired: { default: false, type: Boolean },
    isViewModal: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    setDate: { default: null, type: Function },
    dense: { default: false, type: Boolean },
  },

  data: () => ({
    dateFormatted: null,
    menu1: false,
    fecha: null,
  }),

  mounted() {
    this.init();
  },
  watch: {
    date(val) {
      //Ignora el eco de la fecha que acabamos de emitir para no pisar lo que se esta tipeando
      if (val == this.fecha) return;

      if (val == null) {
        this.fecha = null;
        this.dateFormatted = null;
        this.errors.clear();
        this.$validator.reset();
      } else {
        this.fecha = val;
        this.dateFormatted = this.formatDate(val);
        this.errors.clear();
        this.$validator.reset();
      }
    },
  },
  methods: {
    init() {
      if (this.date == null && this.initToday) {
        let date_aux = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.emitDate(date_aux);
      } else {
        this.fecha = this.date;
        this.dateFormatted = this.formatDate(this.date);
      }
    },
    openMenu() {
      if (this.isViewModal || this.disabled) return;
      this.menu1 = true;
    },
    onPick(val) {
      this.menu1 = false;
      this.emitDate(val);
    },
    //Va formateando dd/mm/aaaa mientras se tipea y emite apenas la fecha es valida
    onInput(val) {
      const digits = (val || "").replace(/\D/g, "").substr(0, 8);

      let masked = digits;
      if (digits.length > 4) masked = digits.substr(0, 2) + "/" + digits.substr(2, 2) + "/" + digits.substr(4);
      else if (digits.length > 2) masked = digits.substr(0, 2) + "/" + digits.substr(2);
      this.dateFormatted = masked;

      const parsed = digits.length == 8 ? this.parseDigits(digits) : null;
      if (parsed != this.fecha) {
        this.fecha = parsed;
        this.$emit("setDate", parsed);
      }
    },
    //Al salir del campo completa lo que falte (dd/mm -> año actual, dd/mm/aa -> 20aa) o revierte si la fecha es invalida
    onBlur() {
      const digits = (this.dateFormatted || "").replace(/\D/g, "");

      if (digits.length == 0) {
        this.emitDate(null);
        return;
      }

      const parsed = this.parseDigits(digits);
      if (parsed == null) {
        //Fecha invalida: vuelve al ultimo valor confirmado por el padre
        this.dateFormatted = this.formatDate(this.date);
        if (this.fecha != this.date) {
          this.fecha = this.date;
          this.$emit("setDate", this.date);
        }
        return;
      }

      this.emitDate(parsed);
    },
    emitDate(date) {
      this.fecha = date;
      this.dateFormatted = this.formatDate(date);
      this.$emit("setDate", date);
    },
    //Acepta ddmm, ddmmaa y ddmmaaaa. Devuelve aaaa-mm-dd o null si no es una fecha real
    parseDigits(digits) {
      let day = "";
      let month = "";
      let year = "";

      if (digits.length == 4) {
        day = digits.substr(0, 2);
        month = digits.substr(2, 2);
        year = String(new Date().getFullYear());
      } else if (digits.length == 6) {
        day = digits.substr(0, 2);
        month = digits.substr(2, 2);
        year = "20" + digits.substr(4, 2);
      } else if (digits.length == 8) {
        day = digits.substr(0, 2);
        month = digits.substr(2, 2);
        year = digits.substr(4, 4);
      } else {
        return null;
      }

      const d = parseInt(day, 10);
      const m = parseInt(month, 10);
      const y = parseInt(year, 10);

      if (y < 1900 || m < 1 || m > 12 || d < 1) return null;

      //Valida los dias reales del mes (contempla años bisiestos)
      const daysInMonth = new Date(y, m, 0).getDate();
      if (d > daysInMonth) return null;

      return year + "-" + month + "-" + day;
    },
    required() {
      if (this.isRequired) return "required";
      return "";
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
